import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

    export class DailyRewardFieldBoundaries extends Phaser.Group {

        constructor(game: Phaser.Game) {

            super(game, null, "daily-reward-field-boundaries", false);

            const upperWall_py = -495;
        
            const upperAndSideWalls = new Phaser.Sprite(this.game, GameConstants.GAME_WIDTH / 2, upperWall_py );
            this.add(upperAndSideWalls);
            this.game.physics.p2.enable( upperAndSideWalls, GameConstants.SHOW_PHYSICS_BODIES );
            upperAndSideWalls.body.setRectangle(GameConstants.GAME_WIDTH , 1000);

            // izquierda
            upperAndSideWalls.body.addRectangle( 305, 1200, -520, 1000);
            // derecha
            upperAndSideWalls.body.addRectangle( 305, 1200, 520, 1000);
            upperAndSideWalls.body.mass = 50;
            upperAndSideWalls.body.setMaterial(GameVars.getInstance().materials.shockAbsorberMaterial);
            upperAndSideWalls.body.static = true;
        }
    }
